import React, { useEffect, useState } from "react";
import Button from "../Button/Button";
import { AssessmentProps } from "../../interfaces/Interface";
import Tooltip from "../Tooltip/Tooltip";
import { getLocalTime, handlingAppName } from "../../helpers/helpers";
import MoreTable from "./MoreTable";

type columnProps = {
  id: string;
  label: string;
  width: number;
};

type DataTableProps = {
  questionId?: string;
  columns: columnProps[];
  rowData: AssessmentProps[];
  onViewHandler?: (arg: AssessmentProps) => void;
};

const DataTable = (props: DataTableProps) => {
  const { onViewHandler, questionId, columns, rowData } = props;
  const [showDetail, setShowDetails] = useState(false);
  const [indexing, setIndexing] = useState(-1);

  useEffect(() => {
    setIndexing(-1);
  }, [rowData]);

  const onClickShowDetails = (index: number) => {
    if (indexing === index) {
      setShowDetails(false);
      setIndexing(-1);
    } else {
      setShowDetails(true);
      setIndexing(index);
    }
  };
  const showItem = (
    value: string,
    column: columnProps,
    row: any,
    index: number
  ) => {
    if (column.id === "results" && row.status === "Completed") {
      return (
        <Button
          onClick={() => onViewHandler?.(row)}
          type={"button"}
          disable={questionId === row.id}
          label="Show Result"
        />
      );
    } else if (column.id === "results" && row.status !== "Completed") {
      return <div>-</div>;
    } else if (column.id === "status" && row.status === "Error") {
      return (
        <div className="flex items-center space-x-2">
          <div>{value}</div>
          <div>
            <Tooltip text={row.message} isError={true} />
          </div>
        </div>
      );
    } else if (column.id === "createdDate") {
      return getLocalTime(value);
    } else if (column.id === "viewDetails") {
      return (
        <div
          className={`${column.width} flex items-center justify-center mr-8`}
        >
          <Button onClick={() => onClickShowDetails(index)} type={"button"}>
            <div>
              {showDetail && index === indexing ? (
                <i className="fa-solid fa-eye-slash"></i>
              ) : (
                <i className="fa-solid fa-eye"></i>
              )}
            </div>
          </Button>
        </div>
      );
    } else {
      return value === null || value === "" ? "-" : value;
    }
  };
  return (
    <div className="relative overflow-x-auto border rounded-sm shadow-md">
      <table className="w-full text-[12px] sm:text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
        <thead className="text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
          <tr>
            {columns.map((item: columnProps, i: number) => {
              return (
                <th
                  scope="col"
                  className={`px-6 py-4 text-sky-700 `}
                  style={{ width: `${item.width}px` }}
                  key={item.id}
                >
                  {item.label}{" "}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody className="w-full">
          {rowData?.length > 0 ? (
            rowData?.map((row: any, _index: number) => {
              return (
                <>
                  <tr
                    key={row.id}
                    className={`${
                      questionId === row.id
                        ? `bg-blue-100 font-semibold text-blue-600`
                        : `bg-white font-normal `
                    } border-b `}
                  >
                    {columns?.map((column: columnProps) => {
                      const value = row[column.id];
                      return (
                        <td
                          key={column.id}
                          className={`px-6 py-4`}
                          style={{ width: `${column.width}px` }}
                        >
                          {showItem(value, column, row, _index)}
                        </td>
                      );
                    })}
                  </tr>
                  {showDetail && indexing === _index && (
                    <tr>
                      <td
                        className="bg-white relative border"
                        colSpan={columns.length}
                      >
                        <MoreTable row={row} />
                      </td>
                    </tr>
                  )}
                </>
              );
            })
          ) : (
            <tr>
              <td className={`px-6 py-4`}>No Records found!</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
